import React from "react";
import { ScanOutlined } from "@ant-design/icons";

export const AI_THEME = {
  primary: "#1890ff",
  primaryHover: "#40a9ff",
  primaryBg: "#e6f7ff",
  accent: "#91d5ff",
  bg: "#f0f2f5",
  card: "#ffffff",
  cardBorder: "#d9d9d9",
  text: "rgba(0, 0, 0, 0.85)",
  muted: "rgba(0, 0, 0, 0.45)",
  success: "#52c41a",
  shadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  radius: 8,
};

export const aiKeyframes = `
@keyframes aiScan {
  0% { top: 10%; opacity: 0.35; }
  50% { opacity: 1; }
  100% { top: 86%; opacity: 0.35; }
}
@keyframes aiPulse {
  0%, 100% { transform: scale(0.96); opacity: 0.75; }
  50% { transform: scale(1.03); opacity: 0.3; }
}
@keyframes aiGlow {
  0%, 100% { box-shadow: 0 0 0 4px rgba(24, 144, 255, 0.12), 0 4px 12px rgba(24, 144, 255, 0.15); }
  50% { box-shadow: 0 0 0 8px rgba(24, 144, 255, 0.18), 0 8px 20px rgba(24, 144, 255, 0.2); }
}
@keyframes aiFadeUp {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
`;

export const AiStyles = () => <style>{aiKeyframes}</style>;

export const AiBadge = ({ label = "AI Face Search" }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "2px 10px",
      borderRadius: 4,
      background: AI_THEME.primaryBg,
      color: AI_THEME.primary,
      border: `1px solid ${AI_THEME.accent}`,
      fontSize: 12,
      fontWeight: 500,
    }}
  >
    <ScanOutlined />
    {label}
  </span>
);

export const AiHero = ({ title, subtitle }) => (
  <div
    style={{
      marginBottom: 24,
      padding: "18px 20px",
      borderRadius: AI_THEME.radius,
      background: AI_THEME.card,
      border: `1px solid ${AI_THEME.cardBorder}`,
      borderLeft: `4px solid ${AI_THEME.primary}`,
      boxShadow: AI_THEME.shadow,
      display: "flex",
      alignItems: "flex-start",
      gap: 14,
    }}
  >
    <div
      style={{
        width: 44,
        height: 44,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: AI_THEME.primaryBg,
        color: AI_THEME.primary,
        fontSize: 22,
        flexShrink: 0,
      }}
    >
      <ScanOutlined />
    </div>
    <div style={{ flex: 1 }}>
      <div
        style={{
          fontSize: 20,
          fontWeight: 600,
          color: AI_THEME.text,
          lineHeight: 1.35,
        }}
      >
        {title}
      </div>
      {subtitle && (
        <div
          style={{
            marginTop: 6,
            fontSize: 14,
            color: AI_THEME.muted,
            lineHeight: 1.5,
          }}
        >
          {subtitle}
        </div>
      )}
    </div>
  </div>
);

export const AiSection = ({ step, title, children, compact = false }) => (
  <div
    style={{
      background: AI_THEME.card,
      border: `1px solid ${AI_THEME.cardBorder}`,
      borderRadius: AI_THEME.radius,
      padding: compact ? "14px 14px" : "20px 22px",
      marginBottom: compact ? 12 : 16,
      boxShadow: AI_THEME.shadow,
      animation: "aiFadeUp 0.35s ease",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: compact ? 12 : 16,
        paddingBottom: compact ? 8 : 12,
        borderBottom: `1px solid ${AI_THEME.cardBorder}`,
      }}
    >
      {step && (
        <span
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: AI_THEME.primaryBg,
            color: AI_THEME.primary,
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {step}
        </span>
      )}
      <span style={{ color: AI_THEME.text, fontWeight: 600, fontSize: 15 }}>
        {title}
      </span>
    </div>
    {children}
  </div>
);

export const aiPageShellStyle = {
  width: "100%",
  padding: "4px 0 8px",
};

export const aiPrimaryButtonStyle = {
  minWidth: 200,
  height: 40,
};

export const aiSecondaryButtonStyle = {
  minWidth: 100,
  height: 40,
};
